/**
 * FerryXpress – custom UX enhancements
 * Laadt na theme.js (defer). Geen conflicten met Shopify/theme logica.
 */
(function () {
  'use strict';

  // ─── 1. DESKTOP ACCOUNT LABEL ─────────────────────────────────────────────
  // Het Warehouse-thema toont op desktop een los tekstlabel boven de link
  // "Konto". Maak ook het label zelf klikbaar, zodat klikken op
  // "Einloggen / Registrieren" niet alleen tekst selecteert.
  var accountTitle = document.querySelector('.header__action-item--account .header__action-item-title');
  if (accountTitle) {
    accountTitle.setAttribute('role', 'link');
    accountTitle.setAttribute('tabindex', '0');
    accountTitle.setAttribute('aria-label', 'Einloggen / Registrieren');
    accountTitle.style.cursor = 'pointer';
    var openAccount = function () {
      window.location.assign('/account/login');
    };
    accountTitle.addEventListener('click', openAccount);
    accountTitle.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openAccount();
      }
    });
  }

  // The base theme hides the mobile navigation below 600px. Keep the
  // existing hamburger button visible on phones without changing its
  // click handler or the menu markup.
  var mobileMenuStyle = document.createElement('style');
  mobileMenuStyle.id = 'fx-mobile-menu-style';
  mobileMenuStyle.textContent = '@media (max-width: 600px) { .header__mobile-nav { display: inline-block !important; flex: 0 0 auto; margin-right: 12px !important; } }';
  (document.head || document.documentElement).appendChild(mobileMenuStyle);

  function restoreMobileMenuVisibility() {
    var mobileNav = document.querySelector('.header__mobile-nav');
    if (!mobileNav) return;
    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
      mobileNav.style.setProperty('display', 'inline-block', 'important');
      mobileNav.style.setProperty('flex', '0 0 auto');
      mobileNav.style.setProperty('margin-right', '12px', 'important');
    } else {
      mobileNav.style.removeProperty('display');
      mobileNav.style.removeProperty('flex');
      mobileNav.style.removeProperty('margin-right');
    }
  }
  restoreMobileMenuVisibility();
  window.addEventListener('resize', restoreMobileMenuVisibility, { passive: true });

  // ─── 2. SLIDESHOW ACCESSIBILITY ───────────────────────────────────────────
  // The Warehouse carousel adds aria-hidden to inactive slides. A slide can
  // itself be an <a>, so keep inactive slides out of the keyboard tree too.
  function syncSlideshowAccessibility() {
    document.querySelectorAll('.slideshow__slide').forEach(function (slide) {
      var isHidden = slide.getAttribute('aria-hidden') === 'true';
      if (isHidden) {
        slide.setAttribute('inert', '');
        slide.setAttribute('tabindex', '-1');
      } else {
        slide.removeAttribute('inert');
        slide.removeAttribute('tabindex');
      }
    });
  }

  syncSlideshowAccessibility();
  if ('MutationObserver' in window) {
    var slideshowObserver = new MutationObserver(syncSlideshowAccessibility);
    document.querySelectorAll('.slideshow__slide').forEach(function (slide) {
      slideshowObserver.observe(slide, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });
    });
  }

  // ─── 3. BACK-TO-TOP BUTTON ────────────────────────────────────────────────
  var btt = document.createElement('button');
  btt.id = 'fx-btt';
  btt.setAttribute('aria-label', 'Nach oben');
  btt.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
  document.body.appendChild(btt);

  window.addEventListener('scroll', function () {
    btt.classList.toggle('fx-btt--visible', window.scrollY > 400);
  }, { passive: true });
  btt.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  // ─── 4. PRODUCT CARD FADE-IN ON SCROLL ────────────────────────────────────
  if ('IntersectionObserver' in window) {
    var cardObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fx-card--visible');
          cardObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    function observeCards() {
      var selectors = [
        '.product-item',
        '.collection__product-list > li',
        '.grid__item',
        '[data-section-type="product-grid"] li',
      ];
      selectors.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          if (!el.classList.contains('fx-card--visible')) {
            cardObserver.observe(el);
          }
        });
      });
    }
    observeCards();

    // Re-observe after AJAX filter updates
    document.addEventListener('collection:reloaded', observeCards);
    document.addEventListener('ajaxComplete', observeCards);
  }

  // ─── 5. FILTER LABEL VERTALINGEN (Engels → Duits) ─────────────────────────
  var tagVertalingen = {
    'lcd': 'LCD', 'oled': 'OLED', 'amoled': 'AMOLED',
    'loud speaker': 'Lautsprecher', 'loudspeaker': 'Lautsprecher',
    'earpiece': 'Hörmuschel', 'earphone': 'Hörmuschel',
    'charging port': 'Ladebuchse', 'charging connector': 'Ladebuchse',
    'battery': 'Akku', 'back cover': 'Backcover', 'backcover': 'Backcover',
    'back glass': 'Rückglas', 'front glass': 'Frontglas',
    'camera lens': 'Kameraobjektiv', 'camera': 'Kamera',
    'frame': 'Rahmen', 'housing': 'Gehäuse', 'chassis': 'Chassis',
    'flex cable': 'Flexkabel', 'flex': 'Flexkabel',
    'sim tray': 'SIM-Halter', 'sim card tray': 'SIM-Halter',
    'volume button': 'Lautstärketaste', 'power button': 'Ein/Aus-Taste',
    'home button': 'Home-Taste', 'home button flex': 'Home-Taste Flex',
    'vibration motor': 'Vibrationsmotor', 'vibrator': 'Vibrationsmotor',
    'proximity sensor': 'Näherungssensor', 'ambient sensor': 'Lichtsensor',
    'screen protector': 'Schutzglas', 'tempered glass': 'Panzerglas',
    'case': 'Hülle', 'cover': 'Hülle', 'silicone case': 'Silikonhülle',
    'cable': 'Kabel', 'charger': 'Ladegerät', 'adapter': 'Adapter',
    'on/off flex': 'Ein/Aus Flex', 'volume flex': 'Lautstärke Flex',
    'digitizer': 'Touchscreen', 'touch screen': 'Touchscreen',
    'motherboard': 'Hauptplatine', 'logic board': 'Hauptplatine',
    'antenna': 'Antenne', 'wifi': 'WLAN', 'bluetooth': 'Bluetooth',
    'speaker': 'Lautsprecher', 'microphone': 'Mikrofon',
    'dock connector': 'Dock-Anschluss', 'headphone jack': 'Kopfhörerbuchse',
    'power flex': 'Power Flex', 'charging flex': 'Lade-Flex',
    's series': 'S-Serie', 'a series': 'A-Serie', 'm series': 'M-Serie',
    'n series': 'N-Serie', 'z series': 'Z-Serie',
    'note series': 'Note-Serie', 'tab series': 'Tab-Serie',
  };

  function translateFilterLabels() {
    document.querySelectorAll('.collection__filter-checkbox label, .collection__active-filter-item').forEach(function (el) {
      var txt = el.textContent.trim().toLowerCase();
      if (tagVertalingen[txt]) {
        el.textContent = tagVertalingen[txt];
      }
    });
  }
  translateFilterLabels();

  // Re-translate after filter panel opens
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action="toggle-collapsible"]');
    if (btn) setTimeout(translateFilterLabels, 50);
  });

  // ─── 6. FILTER PILL ICONS ─────────────────────────────────────────────────
  var pillIcons = {
    'Produkttyp': '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="2" y="2" width="5" height="5" rx="1"/><rect x="9" y="2" width="5" height="5" rx="1"/><rect x="2" y="9" width="5" height="5" rx="1"/><rect x="9" y="9" width="5" height="5" rx="1"/></svg>',
    'Preis':      '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="8" cy="8" r="6"/><path d="M8 5v1.5M8 9.5V11M6.5 7.5C6.5 6.7 7.2 6.5 8 6.5s1.5.5 1.5 1-.5 1-1.5 1-1.5.5-1.5 1S7 11 8 11"/></svg>',
    'Verfügbarkeit': '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 8l3 3 7-7"/></svg>',
    'Marke':      '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M8 2l1.5 3.5L13 6l-2.5 2.5.6 3.5L8 10.5 4.9 12l.6-3.5L3 6l3.5-.5z"/></svg>',
    'Weitere Filter': '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M2 4h12M4 8h8M6 12h4"/></svg>',
  };

  function addPillIcons() {
    document.querySelectorAll('.collection__filter-group-name').forEach(function (btn) {
      if (btn.querySelector('.fx-pill-icon')) return;
      var label = btn.textContent.trim().replace(/\s*[\u25bc\u2193▼↓]+\s*/g, '').trim();
      var svgStr = null;
      for (var key in pillIcons) {
        if (label.toLowerCase().indexOf(key.toLowerCase()) === 0) {
          svgStr = pillIcons[key]; break;
        }
      }
      if (svgStr) {
        var span = document.createElement('span');
        span.className = 'fx-pill-icon';
        span.innerHTML = svgStr;
        btn.prepend(span);
      }
    });
  }
  // Filterpillen blijven bewust tekstueel en rustig; geen extra icoontjes.
  document.querySelectorAll('.fx-pill-icon').forEach(function (icon) {
    icon.remove();
  });

  // ─── 7. SMOOTH SIDEBAR SCROLL ─────────────────────────────────────────────
  document.querySelectorAll('.collection__filter-link').forEach(function (link) {
    link.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  // ─── 8. IMAGE ZOOM → puur CSS (:hover in customized-styles.css) ───────────
  // Geen JS nodig – CSS .product-item:hover img { transform: scale(1.06) }

  // ─── 9. COLLECTION PAGE: BODY CLASS ───────────────────────────────────────
  if (document.body.dataset.pageType === 'collection' || document.querySelector('.collection__products-count')) {
    document.body.classList.add('fx-collection-page');
  }

})();
